// AUTH ROUTES

export const AUTH = '/';
export const LOGIN = '/login';

// DASHBOARD ROUTES

export const DASHBOARD = '/user-table';
export const ADMIN = '/admin';
export const ADD_MASTER_EMPLOYEE = '/add-master-employee';
export const PROPERTY_LISTING = '/property';
export const ROLE_PERMISSIONS = '/roles-permissions';
export const ENQUIRY = '/enquiry';
export const PROPERTY_ENQUIRY = '/enquiry/properties-enquiry';
export const USER_REQUIREMENTS = '/enquiry/user-requirements';
export const PROJECT = '/project';
export const PROJECT_ENQUIRY = '/enquiry/project-inquiry';
export const SOLDOUT_INQUIRY = '/enquiry/soldout-inquiry';
export const PROJECT_FORM = PROJECT + '/form';
export const PROJECT_PROMOTION = PROJECT + '/project-promotion';
export const PROJECT_LINK_VIDEO = PROJECT + '/link-video';
export const PROJECT_LINK_VIDEO_ADD = PROJECT_LINK_VIDEO + '/add';
export const PROJECT_COINVESTMENT = '/project-co-investment';
export const ADD_PROJECT_COINVESTMENT = PROJECT_COINVESTMENT + '/add';
export const UPDATE_PROJECT_COINVESTMENT =
  '/project-co-investment/update/:co_investment_project_id';
export const PROJECT_PROMOTION_FORM = PROJECT + '/project-promotion/form';
export const PROJECT_PROMOTION_UPDATE_FORM =
  PROJECT + '/project-promotion/form/:promotionId';
export const UPDATE_PROJECT_FORM = '/project/form/:projectId';
export const PROPERTY_FORM = '/property/form/:propertyId';
export const PROPERTY_FORM_ADD = '/property/add';
export const UPDATE_PROPERTY_FORM = '/property/add/:propertyId';
export const ADD_PROPERTY_LISTING = '/property/add-property';
export const POTENTIAL_BUYER = '/potential-buyer';
export const DEVELOPER = '/developer';
export const DEVELOPER_FORM = DEVELOPER + '/form';
export const LOCALITY = '/locality';
export const LOCALITY_FORM = LOCALITY + '/form';
export const BLOGS_FORM = '/blogs/form';
export const BLOGS = '/blogs';
export const SEO_CONTENT = '/seo-content';
export const LOCALITY_DESCRIPTIONS = '/locality-descriptions';
export const SEO_CONTENT_FORM = SEO_CONTENT + '/form';
export const LOCALITY_CONTENT_FORM = LOCALITY_DESCRIPTIONS + '/form';
export const SUBSCRIPTION_FORM = '/subscription/form';
export const SUBSCRIPTION = '/subscription';
export const SUBSCRIPTION_ANALYTICS =
  '/subscription/analytics/:userSubscriptionId';
export const BUILDER_SUBSCRIPTION_FORM = '/builder-subscription/form';
export const BUILDER_SUBSCRIPTION_EDIT = '/builder-subscription/edit/:subscriptionId';
export const BUILDER_SUBSCRIPTION = '/builder-subscription';
export const ROLES = '/admin-users';
export const PROPERTY_REPORT = '/property/property-report';
export const CHATINFO = '/chatinfo';
export const PROFILE = '/profile';
export const USER_SUBSCRIPTION = '/user-subscription';
// MESSAGE SERVICE ROUTES
export const MESSAGE_SERVICE = '/message-service';

// Campaign Routes
export const CAMPAIGNS = MESSAGE_SERVICE + '/campaign';
export const CREATE_CAMPAIGN = CAMPAIGNS + '/create';
export const EDIT_CAMPAIGN = CAMPAIGNS + '/edit/:campaignId';
export const CAMPAIGN_DETAILS = CAMPAIGNS + '/:campaignId';
export const CAMPAIGN_TRANSACTION_DETAILS =
  MESSAGE_SERVICE + '/campaign-transaction/:campaignTransactionId';

// Cron Routes
export const CRONS = MESSAGE_SERVICE + '/cron';
export const CREATE_CRON = CRONS + '/create';
export const CREATE_REGULAR_CRON = CRONS + '/create/regular';
export const CREATE_PERIODIC_CRON = CRONS + '/create/periodic';
export const EDIT_CRON = CRONS + '/edit/:cronId';
export const CRON_DETAILS = CRONS + '/:cronId';
export const CRON_TRANSACTION_DETAILS =
  MESSAGE_SERVICE + '/cron-transaction/:cronTransactionId';

// WhatsApp Send Route
export const WHATSAPP_SEND = MESSAGE_SERVICE + '/whatsapp-send';

// Template Routes
export const TEMPLATES = MESSAGE_SERVICE + '/templates';
export const CREATE_TEMPLATE = TEMPLATES + '/create';
export const EDIT_TEMPLATE = TEMPLATES + '/edit/:templateId';
export const TEMPLATE_DETAILS = TEMPLATES + '/:templateId';
